
/* eslint vue/no-unused-components: 0 */
import IconEnvelope from '~/components/icon/IconEnvelope.vue';
import IconGlobe from '~/components/icon/IconGlobe.vue';
import IconPhone from '~/components/icon/IconPhone.vue';
import promiseErrors from '~/services/promiseErrors';

export default {
    name: 'CouncilView',
    async asyncData({ app, route }) {
        const [council, stats] = await promiseErrors(
            [
                app.$axios.$get(`${app.$config.endpoints.council}/${route.params.council}`),
                app.$axios.$get(`${app.$config.endpoints.council}/${route.params.council}/stats`),
            ],
            app,
        );
        const [reports] = await promiseErrors(
            [
                app.$axios.$get(app.$config.endpoints.report, {
                    params: {
                        page: 1,
                        per_page: 6,
                        council_id: council ? council.council.id : null,
                    },
                }),
            ],
            app,
        );
        return {
            council: council ? council.council : {},
            reports: reports ? reports.reports.data : [],
            stats: stats ? stats.stats : {},
        };
    },
    data() {
        return {
            council: {},
            stats: {},
        };
    },
    head() {
        return {
            title: `${this.council.name} - ClearWaste`,
            meta: [{ hid: 'description', name: 'description', content: this.$t('metadata.council.text', { council: this.council.name }) }],
        };
    },
    computed: {
        items() {
            const items = [];
            if (this.council.email) {
                items.push({ icon: IconEnvelope, html: `<a href="mailto:${this.council.email}">${this.council.email}</a>` });
            }
            if (this.council.telephone) {
                items.push({ icon: IconPhone, html: `<a href="tel:${this.council.telephone}">${this.council.telephone}</a>` });
            }
            if (this.council.url) {
                items.push({ icon: IconGlobe, html: `<a href="${this.council.url}" target="_blank">${this.council.url}</a>` });
            }

            return items;
        },
    },
};
